import React, { useMemo } from 'react';
import { Form, Select, Input, InputNumber, Row, Col, Typography } from 'antd';
import FormDependency from 'components/FormDependency';
import useFormatMessage from 'hooks/useFormatMessage';
import { getMetricLabel } from 'components/MetricLabel';
import standardMetrics from 'shared/constants/metrics';

const MetricConfig = () => {
  const $t = useFormatMessage();
  const metricOptions = useMemo(() => {
    const options = Object.entries(standardMetrics).map(([m]) => ({
      label: getMetricLabel({ $t, metric: m }),
      value: m,
    }));
    return options;
  }, [$t]);

  const hasPrecisionSettings = (metricKey) => {
    const type = standardMetrics[metricKey]?.type;
    return type === 'number' || type === 'percent';
  };

  return (
    <>
      <Form.Item label="Metric" name="metric">
        <Select options={metricOptions} showSearch optionFilterProp="label" />
      </Form.Item>
      <FormDependency name="metric" show={value => !value}>
        <Form.Item>
          <Typography.Text type="secondary">
            Select a metric from the result config before editing settings.
          </Typography.Text>
        </Form.Item>
      </FormDependency>
      <FormDependency name="metric" show={value => !!value}>
        <Form.Item label="Label" name="label">
          <Input.TextArea rows={2} />
        </Form.Item>
        <Row gutter={16}>
          <Col>
            <Form.Item label="Sort priority" name="sortPriority">
              <InputNumber />
            </Form.Item>
          </Col>
          <Col>
            <Form.Item label="Sort order" name="sortOrder">
              <Select options={[
                { label: 'Ascending', value: 'asc' },
                { label: 'Descending', value: 'desc' },
              ]}
              />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item label="Column width" name="width">
          <InputNumber min={50} max={400} />
        </Form.Item>
        <FormDependency name="metric" show={hasPrecisionSettings}>
          <Row gutter={16}>
            <Col>
              <Form.Item label="Decimals (table/chart)" name="precision">
                <InputNumber min={0} max={10} placeholder="0" />
              </Form.Item>
            </Col>
            <Col>
              <Form.Item label="Decimals (tooltip)" name="tooltipPrecision">
                <InputNumber min={0} max={10} placeholder="2" />
              </Form.Item>
            </Col>
          </Row>
        </FormDependency>

      </FormDependency>
    </>
  );
};
export default MetricConfig;
